export default __webpack_public_path__ + "static/media/i-settings@3x.4c1d75d5.webp";